export const SHOPFLO_SCRIPT_SRC = 'https://bridge.shopflo.com/v2/shopflo.js';

export const SHOPFLO_PROVIDER_ID = 'shopflo' as const;
